module.exports = __webpack_public_path__ + "static/media/skyy2.fdb11afb.jpg";